import { render, staticRenderFns } from "./formAddEditAnnounce.vue?vue&type=template&id=446c38dc&scoped=true"
import script from "./formAddEditAnnounce.vue?vue&type=script&lang=js"
export * from "./formAddEditAnnounce.vue?vue&type=script&lang=js"
import style0 from "./formAddEditAnnounce.vue?vue&type=style&index=0&id=446c38dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c38dc",
  null
  
)

export default component.exports